import { IIconBuilder } from 'interfaces/iconBuilder'
import { IOption, IOptionWithIcon } from 'types/common'
import { getValidArray } from 'utils/common'
import { getName } from 'utils/users'
import { ECollectionFilterName } from './contants'

export function getOptionSelect<T extends { id?: number; _id?: number; name?: string; iconBuilder?: IIconBuilder }>(
  items: T[]
): IOptionWithIcon<string>[] {
  let itemOptions: IOptionWithIcon<string>[] = []
  let options: string[] = []
  getValidArray(items).forEach((item: T) => {
    const id = item?.id ?? (item as { _id?: number })?._id
    if (id != null && !options.includes(String(id)) && (item?.name || !!getName(item))) {
      options = options.concat(String(id))
      itemOptions = [
        ...itemOptions,
        {
          value: String(id),
          label: item?.name ?? getName(item) ?? '',
          icon: item?.iconBuilder
        }
      ]
    }
  })
  return itemOptions
}

export function getItemIds(params: URLSearchParams, collectionName: string): number[] {
  return params.get(collectionName)
    ? (params
        .get(collectionName)
        ?.split(',')
        ?.map((id: string) => Number(id)) ?? [])
    : []
}

function getItemId<T extends { id?: number; _id?: number }>(item: T): number {
  return item?.id ?? (item as { _id?: number })?._id ?? 0
}

export function filterCurrentItems<T extends { id?: number; _id?: number; name?: string }>(
  params: URLSearchParams,
  name: string,
  itemList: T[]
): T[] {
  const itemIds: number[] = getItemIds(params, name)
  const currentItems = getValidArray(itemList).filter(item => itemIds.includes(getItemId(item)))
  return currentItems
}

export function filterRemainItem<T extends { id?: number; _id?: number; name?: string }>(
  itemList: T[],
  selectedItem: IOption<string>[]
): T[] {
  const item = getValidArray(itemList).filter(
    (group: T) => !getValidArray(selectedItem).find((option: IOption<string>) => option?.value === String(getItemId(group)))
  )

  return item
}

export function filterSubmitItems(selectedItems: IOption<string>[]): string {
  return selectedItems.map(item => item?.value).join(',')
}
